import React from 'react';
import './result.css';

export default function Result(props) {
  const {containerStyle, cards, onCardClick} = props;

  return (
    <div style={containerStyle} className="cards-without-text-result">
      {cards.map((box, index) => {
        return (
          <div style={box.style} key={index} tabIndex={0} onClick={onCardClick(index)} className="cards-additional-style-class"></div>
        );
      })}
    </div>
  );
}
